import styled from 'styled-components'
import { PRIMARY_COLOR, MEDIUMORANGE } from '../../../styles/colors.style'
import { breakpoints } from '../../../constants/breakpoits.constants'

export const HEADER_HEIGHT = 9.5

const PreLaunchContainer = styled.section`
	background-image: none;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: ${(props) => (props.isMobile ? '0px' : '140px')};
	position: relative;
	width: 100%;

	@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
		margin-top: 10px;
	}

	@media screen and (max-width: ${breakpoints.MOBILE}px) and (orientation: landscape) {
		padding-top: ${HEADER_HEIGHT}rem;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		align-items: center;
		background-repeat: no-repeat;
		margin-top: 93px;
		height: 43.4rem;
		background-position-x: center;
		/* background-color: #ffb34f; */

		.pre-launch-carousel {
			width: 100%;
		}
	}

	@media screen and (min-width: ${breakpoints.NOTEBOOK}px) {
		height: 45.4rem;
	}

	@media screen and (min-width: 1400px) {
		height: 48.4rem;
	}

	.angle-down {
		transition: color 0.5s;

		&:hover {
			color: ${PRIMARY_COLOR};
			cursor: pointer;
		}
	}

	.info {
		max-width: 950px;
		padding: 30px 15px;

		@media (min-width: 768px) {
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			height: 60%;
			justify-content: center;
			margin: 0 auto;
			width: 100%;

			.angle-down {
				display: none;
			}
		}

		@media (min-width: ${breakpoints.MOBILE}px) {
			height: 100%;
			width: 50%;
		}

		.angle-down {
			bottom: 1rem;
			left: calc(50% - 13px);
			position: absolute;
		}

		.pre-launch-carousel {
			align-self: center;
			margin-bottom: 8rem;
			margin: 0 auto;
			max-width: 600px;
			-webkit-align-self: center;
			-ms-flex-item-align: center;
		}
	}

	.trip-search-section {
		align-items: center;
		display: flex;
		justify-content: center;

		.angle-down {
			display: none;
		}

		@media (min-width: ${breakpoints.MOBILE}px) {
			height: 0;
			position: relative;
			top: 25px;
			width: 90% !important;

			.social-links {
				bottom: 8rem;
				position: absolute;
				right: 8rem;
			}

			.angle-down {
				background: ${PRIMARY_COLOR};
				border-radius: 50%;
				bottom: 8rem;
				color: #fff;
				display: initial;
				left: -20px;
				position: absolute;
				text-align: center;
				width: 40px;
			}
		}
	}

	.container-banners {
		height: 100%;
		width: 100%;
		background-color: #fff;
	}
	.banner-mobile {
		display: none;
	}

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		.container-banners {
			display: none;
		}
		.banner-mobile {
			display: block;
			background: ${MEDIUMORANGE};
			.img-responsive {
				display: block;
				width: 100%;
			}
		}
	}
`

export default PreLaunchContainer
